import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "config",
  "use": "config-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"config\"><g fill-rule=\"nonzero\"><path d=\"M6 1.08V0H2v1.08H0v1.36h2V4h4V2.44h10V1.08zM14 4.95h-4v1.32H0v1.35h10v1.33h4V7.62h2V6.27h-2zM9 10H5v1.32H0v1.35h5V14h4v-1.33h7v-1.35H9z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id